exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".q-edit-content[data-v-9f9612fe] {\n  width: 100%;\n  margin-top: 10px;\n}\n.q-edit-content[data-v-9f9612fe]  .com-input.code {\n    margin-top: 5px;\n    width: 60%;\n}\n.q-edit-content[data-v-9f9612fe]  .com-button {\n    font-size: 12px;\n    padding: 6px 20px;\n}\n.q-edit-content[data-v-9f9612fe]  .com-button.code {\n      margin-top: 5px;\n      width: 39%;\n      margin-left: 1px;\n}\n.q-edit-content[data-v-9f9612fe]  .error-msg {\n    position: absolute;\n    color: #fc5659;\n    padding-left: 10px;\n    line-height: 20px;\n    font-size: 12px;\n}\n", ""]);

// exports
